export default "__VITE_ASSET__wwOEU3UW__"